import { BusInternal } from '../../config';
import { getCall, genericGetCall, genericPostCall } from '../../utils/apiCalls'

import {
  RESET_STORE,
  CATEGORY_LIST,
  SERVICES_LIST,
  META_DETAILS,
  // SET_PHOTOS_TO_UPLOAD,
  GO_TO_PHOTOS_SELECTION,
  GO_TO_SERVICES_SELECTION,
  SELECT_ALL_SERVICES_HANDLER,
  GO_TO_CATEGORY_SELECTION,
  UPLOAD_SELECTED_PHOTOS_HANDLER,
  SELECT_INDIVIDUAL_SERVICES_HANDLER
} from './actionTypes';

import { GET_BUS_CATEGORIES_LIST, GET_META_DETAILS, BUS_PHOTO_UPLOAD } from '../../config/urls';

const ErrorMsg = 'Error Occurred, please try later.';

export const fetchMetaDetails = () => dispatch => {
  genericGetCall(BusInternal+GET_META_DETAILS)
    .then(res => {
      if(res && res.status === 200) {
        // in case of no meta details
        if(!res.data.body || !res.data.body.content) return;

        dispatch({
          type: META_DETAILS,
          payload: { data: res.data.body.content || {} },
        })
      } else
        alert(ErrorMsg);
    })
}

export const fetchBusCategories = query => dispatch => {
  getCall(GET_BUS_CATEGORIES_LIST, query)
    .then(res => {
      if(res && res.data && res.data.categories && res.data.categories.length)
        dispatch({
          type: CATEGORY_LIST,
          payload: { data: res.data.categories || [] },
        })
      else if(res && res.data && res.data.statusCode >= 400) {
        let error = ((res.data || {}).errorObj || {}).message || ErrorMsg;
        alert(error);
      } else
        alert(ErrorMsg);
    })
}

export const goToBusCategories = dispatch => ({
  type: GO_TO_CATEGORY_SELECTION
})

export const fetchBusServices = busCategory => dispatch => {
  getCall(GET_BUS_CATEGORIES_LIST + '/' + busCategory)
    .then(res => {
      if(res && res.data && res.data.route_info) {
        if(res.data.route_info.length) {
            dispatch({
              type: SERVICES_LIST,
              payload: {
                busCategory,
                servicesForCategory: res.data.route_info
              }
            });
        } else {
          alert('No Routes found the selected category.');
        }
      } else {
        alert(ErrorMsg);
      }
    })
}

export const goToBusServices = dispatch => ({
  type: GO_TO_SERVICES_SELECTION
})

export const goToPhotoSelection = dispatch => ({
  type: GO_TO_PHOTOS_SELECTION
})

export const selectAllServicesHandler = isSelectAllServices => dispatch => {
  dispatch({
    type: SELECT_ALL_SERVICES_HANDLER,
    payload: { isSelectAllServices }
  })
}

export const selectIndividualServicesHandler = (isSelectedService, selectedRoute) => dispatch => {
  dispatch({
    type: SELECT_INDIVIDUAL_SERVICES_HANDLER,
    payload: {isSelectedService, selectedRoute}
  })
}

// export const setPhotosToUpload = (uploadSelectedPhotos) => dispatch => {
//   dispatch({
//     type: SET_PHOTOS_TO_UPLOAD,
//     payload: {uploadSelectedPhotos}
//   })
// }

export const uploadSelectedPhotosHandler = (formDataArr, callback) => dispatch => {
  let promises = formDataArr.map(data => genericPostCall(BusInternal+BUS_PHOTO_UPLOAD, data));
  Promise.all(promises)
    .then(dataArr => {
      let successCount = 0, failCount = 0, successFileNames = [], err = '';
      dataArr.forEach(el => {
        if(el && el.status === 200) {
          successCount++;
          if(el.data && el.data.name) successFileNames.push(el.data.name);       
        } else {
          failCount++;
          err = ((el.response.data || {}).meta || {}).error;
        }
      })
      if (successCount) {
        dispatch({
          type: UPLOAD_SELECTED_PHOTOS_HANDLER,
          payload: { successCount, failCount, successFileNames }
        })
      } else {
        alert(err || 'Failed to upload images, please try again.');
      }
    })
}

export const resetStore = () => ({
  type: RESET_STORE
})
